import { render, staticRenderFns } from "./ProIndex.vue?vue&type=template&id=147daf0c&scoped=true&"
import script from "./ProIndex.vue?vue&type=script&lang=js&"
export * from "./ProIndex.vue?vue&type=script&lang=js&"
import style0 from "./ProIndex.vue?vue&type=style&index=0&id=147daf0c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "147daf0c",
  null
  
)

export default component.exports